export default {
  ReadPropsSite(action, self, onReadSuccess, onReadFailed) {
  //console.log(self.props)
  // console.log('ReadPropsSite')
  // console.log(self)
    return {

      data : {
        AuthorizationToken : self.props.UserReducer.token,
      },
      action : action,
      self: self,
      //selectedData: selectedData,
      //Reducer: self.props.Reducer,
      //RunRedux : self.props.RunRedux,
      onsuccess : onReadSuccess,
      onfailed : onReadFailed,
      //order:order
    }
  },
  ReadPropsSiteAsset(action, self, onReadSuccess, onReadFailed, selectedAlias=null) {
  // console.log('ReadPropsSiteAsset')
  // console.log(self)
    return {

      data : {
        AuthorizationToken : self.props.UserReducer.token,
      },
      action : action,
      self: self,
      selectedAlias: selectedAlias,
      //Reducer: self.props.Reducer,
      //RunRedux : self.props.RunRedux,
      onsuccess : onReadSuccess,
      onfailed : onReadFailed,
      //order:order
    }
  },
  ReadMasterSiteType(action, self, onReadSuccess, onReadFailed) {
    return {
      data : {
        AuthorizationToken : self.props.UserReducer.token,
      },
      action : action,
      self: self,
      onsuccess : onReadSuccess,
      onfailed : onReadFailed,
    }
  },
  ReadMasterSiteStatus(action, self, onReadSuccess, onReadFailed) {
    return {
      data : {
        AuthorizationToken : self.props.UserReducer.token,
      },
      action : action,
      self: self,
      onsuccess : onReadSuccess,
      onfailed : onReadFailed,
    }
  },
}




// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/request.props.js